import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { region, taskAssign } from "../../config/images";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from "@mui/material/Pagination";
import { useNavigate } from "react-router-dom";

const UserManagement = () => {
  const [addUserpopup, setAddUserPopup] = useState(false);
  const [editUserpopup, setEditUserPopup] = useState(false);
  const [deleteUserpopup, setDeleteUserPopup] = useState(false);
  const data = [
    {
      srNo: "01",
      name: "Admin",
      permission:
        "Task assignment, Task assignment, Collectors, Report Submission Category Master, User Management ",
    },
    {
      srNo: "02",
      name: "Super Admin",
      permission:
        "Task assignment, Task assignment, Collectors, Report Submission Category Master, User Management ",
    },
  ];

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const navigate = useNavigate();
  return (
    <>
      <Box className="task-detail-box">
        <Box
          className="d-flex justify-content-between align-items-center"
          style={{ flexWrap: "wrap" }}
        >
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={region.region}
              alt=""
              style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
              User Management
            </Typography>
          </Box>
          <Box className="pt-3 d-flex align-items-center assign-data-btn">
            <img
              src={region.deleteIcon}
              alt=""
              style={{ marginRight: "10px" }}
              className="delete-btn"
            />
            <button
              className="assign-task-btn"
              style={{ height: "46px", marginLeft: "0px" }}
              onClick={() => setAddUserPopup(true)}
            >
              Add User
            </button>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #31A05F",
            borderRadius: "4px",
            overflow: "hidden",
            margin: "0px 20px",
          }}
          className="mt-3"
        >
          <TextField
            placeholder="Search here"
            variant="outlined"
            size="small"
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            // InputProps={{
            //   startAdornment: (
            //     <InputAdornment position="start">
            //       <SearchIcon sx={{ color: "#31A05F" }} />
            //     </InputAdornment>
            //   ),
            // }}
          />
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#31A05F",
              color: "#fff",
              borderRadius: "0",
              textTransform: "none",
              px: 3,
              padding: "8px 25px",
              "&:hover": {
                backgroundColor: "#45A049",
              },
            }}
          >
            <SearchIcon /> Search
          </Button>
        </Box>
        <Box style={{ width: "100%", overflowX: "auto" }}>
          <Table className="region-table mt-4">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "50px" }}>
                <Checkbox
                      sx={{
                        color: "rgba(225, 230, 244, 1)",
                        borderRadius: "4px",
                        "&.Mui-checked": {
                          color: "rgba(199, 206, 227,1)",
                        },
                      }}
                    />
                </TableCell>
                <TableCell style={{ width: "100px" }}>Sr.No</TableCell>
                <TableCell>User Role</TableCell>
                <TableCell>Permissions</TableCell>
                <TableCell style={{ width: "100px" }} colSpan={2}>
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((e) => {
                return (
                  <TableRow>
                    <TableCell>
                    <Checkbox
                      sx={{
                        color: "rgba(225, 230, 244, 1)",
                        borderRadius: "4px",
                        "&.Mui-checked": {
                          color: "rgba(199, 206, 227,1)",
                        },
                      }}
                    />
                    </TableCell>
                    <TableCell>{e.srNo}</TableCell>
                    <TableCell>{e.name}</TableCell>
                    <TableCell>{e.permission}</TableCell>
                    <TableCell>Active</TableCell>
                    <TableCell>
                      <div className="d-flex gap-3">
                        <img
                          src={region.editIcon}
                          alt=""
                          onClick={() => setEditUserPopup(true)}
                          style={{ cursor: "pointer", height: "23px" }}
                        />
                        <img
                          src={region.deleteIcon}
                          alt=""
                          onClick={() => setDeleteUserPopup(true)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
        <Box display="flex" justifyContent="end" alignItems="center">
          <Stack spacing={2} className="mb-2">
            <CustomPagination
              count={4}
              page={1}
              //   onChange={handlePageChange}
              // variant="outlined"
              color="primary"
            />
          </Stack>
        </Box>

        <Dialog
          open={addUserpopup}
          onClose={() => setAddUserPopup(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
          // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Add User
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label="Enter User"
                name="taskTitle"
                // value={taskData.taskTitle}
                // onChange={handleChange}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  // onClick={handleSubmit}
                >
                  Cancel
                </button>
                <button
                  className="assign-task-button"
                  onClick={() => navigate("/user-management-detail")}
                >
                  Add User
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog
          open={editUserpopup}
          onClose={() => setEditUserPopup(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
          // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                Edit User
              </h5>
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label="Enter User"
                name="taskTitle"
                // value={taskData.taskTitle}
                // onChange={handleChange}
                className="mb-3"
              />

              <div className="d-flex gap-3 mt-2">
                <button
                  className="cancel-button"
                  // onClick={handleSubmit}
                >
                  Cancel
                </button>
                <button
                  className="assign-task-button"
                  // onClick={handleSubmit}
                >
                  Update User
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>

        <Dialog
          open={deleteUserpopup}
          onClose={() => setDeleteUserPopup(false)}
          maxWidth="xs"
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        >
          <DialogContent className="p-5" style={{ textAlign: "center" }}>
            <Box>
              <img src={region.correct} alt="" />
            </Box>
            <Typography variant="h5" className="pt-4 mb-2">
              <b>Delete this User </b>
            </Typography>
            <Typography
              variant="p"
              className="pt-4"
              style={{ fontSize: "16px" }}
            >
              Are you sure you want to <br />
              delete this User{" "}
            </Typography>
            <div className="d-flex gap-3 pt-4">
              <button
                className="assign-task-button"
                onClick={() => setDeleteUserPopup(false)}
              >
                Yes
              </button>
              <button
                className="assign-task-button"
                onClick={() => setDeleteUserPopup(false)}
              >
                No
              </button>
            </div>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default UserManagement;
